import SurveyCollector from './components/SurveyCollector';
export default SurveyCollector;